module.exports = __webpack_public_path__ + "static/media/binance-logo.a91cc2db.svg";